import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "confect-settings-box",
  templateUrl: "./confect-settings-box.component.html",
  standalone: false,
})
export class CSettingsBoxComponent {
  @Input({ required: true }) cardTitle: string;
  @Input() buttonText: string;
  @Input() subtitle: string;

  @Output() buttonClick = new EventEmitter<any>();
}
